import React from "react";
import TableContainer from "../Accounts/Account/Transactions/Table/TableContainer";
import Aux from "../../hoc/Auxiliary";
import {useTranslation} from "react-i18next";

const Panel = (props) => {
    const { t, i18n } = useTranslation();

    let periodToShow= "";
    switch (props.period) {
        case "current_period":
            periodToShow = t("docs.invoices.table.filter.currentperiod");
            break;
        case "last_14":
            periodToShow = t("docs.invoices.table.filter.last_14");
            break;
            case "last_30":
                periodToShow = t("docs.invoices.table.filter.last_30");
            break;
            case "specific_date":
                periodToShow = t("docs.invoices.table.filter.specific_date");
            break;
    }

    return (
        <div className="map-panel">
            <div className="map-panel__header">
                <h3 className="map-panel__header__title">
                    Transactions - {props.data.name} - {periodToShow != "" ? ('('+periodToShow+')') : '' }
                </h3>
                <div className="map-panel__header__close" onClick={props.closePopup}><i
                    className="fal fa-times"></i></div>
            </div>
            <div className="map-panel__content">
                {props.children}
            </div>
        </div>
    );
};


export default Panel;


